<mat-form-field id="text">
  <mat-label *ngIf="placeholder">{{ placeholder }}</mat-label>
  <input [formControl]="field" matInput="" type="text" />
</mat-form-field>
